import { render, staticRenderFns } from "./CashaccountLayout.vue?vue&type=template&id=21c960e4&scoped=true&"
import script from "./CashaccountLayout.vue?vue&type=script&lang=js&"
export * from "./CashaccountLayout.vue?vue&type=script&lang=js&"
import style0 from "./CashaccountLayout.vue?vue&type=style&index=0&id=21c960e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c960e4",
  null
  
)

export default component.exports